// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAKLnJAld9JRL9tMvdtCyzS1GAtKZ0MG9Q",
    authDomain: "proeconomy-tetras.firebaseapp.com",
    projectId: "proeconomy-tetras",
    storageBucket: "proeconomy-tetras.appspot.com",
    messagingSenderId: "227690124021",
    appId: "1:227690124021:web:dc32c3dfd76c37af0dabbc",
    measurementId: "G-PEL65TT70L"    
  },
  googleMapsApiKey: "AIzaSyABrbzcuAT3AHkmHR-MkYPdHknQhn1PAKc",
  timeStamp: '05/11/2026 10:45:29 AM'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
